import React, { useState, useEffect, useCallback } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import PageHeader from '../../components/PageHeader';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import ViewModal from '../../components/modal';
import TooltipInfo from '../../components/TooltipInfo'
import { useUsers } from '../../context/usersContext';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';


const initializeInternalHealthcare = () => ({
  date: new Date().toISOString().slice(0, 16),
  type_care: "",
  conduct: "",
  general_health_status: "",
  anamnesis: "",
  prescription: "",
  observation: "",
  internal: "",
  data: ""
});


const InternalCareHealth = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { buildUnitReadParams } = useUsers();

  const {
    listInternals,
    createInternalHealthCare,
    listInternalHealthCare,
    updateInternalHealthCare,
  } = useInternals();

  const [typeServiceCareOptions, setTypeServiceCareOptions] = useState([]);
  const [internalHealthcareData, setInternalHealthcareData] = useState(initializeInternalHealthcare());
  const [internalHealthcareRecords, setInternalHealthcareRecords] = useState([]);
  const [editHealthcare, setEditHealthcare] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [internalDetails, setInternalDetails] = useState(null);
  const { listTypeservicecare, listRemedies, listTypeTest } = useAuxiliaries();


  const handleInternalHealthcareChange = (e) => {
    const { name, value } = e.target;
    setInternalHealthcareData((prev) => ({ ...prev, [name]: value }));
  };

  // Submissão de Atendimento Interno
  const handleInternalHealthcareSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!internalDetails?.id) return toast.error("Nenhum interno selecionado.");

      try {
        const payload = {
          ...internalHealthcareData,
          internal: internalDetails.id,
          type_care: internalHealthcareData.type_care ? Number(internalHealthcareData.type_care) : null,
          general_health_status: internalHealthcareData.general_health_status || null,
        };

        await createInternalHealthCare(payload);

        const updated = await listInternalHealthCare(internalDetails.id);
        setInternalHealthcareRecords(updated.results || []);
        setInternalHealthcareData(initializeInternalHealthcare());
      } catch (err) {
        console.error("Erro ao salvar atendimento interno:", err);
        toast.error("Erro ao salvar atendimento interno.");
      }
    });
  };

  // Atualização de Atendimento Interno (modal)
  const handleInternalHealthcareUpdate = async (e) => {
    e.preventDefault();
    if (!editHealthcare) return;
    try {
      const payload = {
        ...editHealthcare,
        internal: internalDetails.id,
        type_care: editHealthcare.type_care ? Number(editHealthcare.type_care) : null,
        general_health_status: editHealthcare.general_health_status || null,
      };
      await updateInternalHealthCare(editHealthcare.id, payload);
      const updated = await listInternalHealthCare(internalDetails.id); setInternalHealthcareRecords(updated.results || []);
      setEditHealthcare(null);
    } catch (err) {
      console.error("Erro ao atualizar atendimento interno:", err);
      toast.error("Erro ao atualizar atendimento interno.");
    }
  };


  const loadAuxiliaryData = useCallback(async () => {
    try {
      const [
        serviceCareData,
      ] = await Promise.all([
        listTypeservicecare(),
        listRemedies(),
        listTypeTest(),
      ]);
      setTypeServiceCareOptions(serviceCareData?.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados auxiliares:', error);
    }
  }, [listTypeservicecare, listRemedies, listTypeTest]);

  const handleInternalSelect = useCallback(async (internal) => {
    if (!internal?.id) {
      toast.error("Erro ao selecionar interno.");
      return;
    }
    try {
      setInternalDetails(internal);
      // Consulta interna
      const updated = await listInternalHealthCare(internal.id);
      setInternalHealthcareRecords(updated.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados do interno:', error);
      toast.error('Erro ao carregar dados do interno.');
    }
  }, [listInternalHealthCare]);


  // abrir modaal de consulta por id
  // const handleOpenHealthcareFromRecord = (healthcareId) => {
  //   const consulta = internalHealthcareRecords.find(c => c.id === healthcareId);
  //   if (consulta) {
  //     setEditHealthcare(consulta);
  //   } else {
  //     toast.error("Consulta não encontrada.");
  //   }
  // };

  useEffect(() => {
    if (internalId) {
      handleInternalSelect({ id: internalId });
    }
  }, [internalId, handleInternalSelect]);

  useEffect(() => {
    if (internalDetails?.id) {
      (async () => {
        try {
          const updated = await listInternalHealthCare(internalDetails.id); setInternalHealthcareRecords(updated.results || []);
        } catch (err) {
          setInternalHealthcareRecords([]);
        }
      })();
    }
  }, [internalDetails, listInternalHealthCare]);

  useEffect(() => {
    loadAuxiliaryData();
  }, [loadAuxiliaryData]);

  useEffect(() => {
    if (internalId) {
      const fetchInternalById = async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internalData = response?.results?.[0];

          if (internalData) {
            handleInternalSelect(internalData)
          }
        } catch (error) {
          console.error("Erro ao carregar interno pelo ID:", error);
          toast.error("Erro ao carregar interno.");
        }
      };

      fetchInternalById();
    }
  }, [internalId, handleInternalSelect, listInternals, buildUnitReadParams]);

  // --- Renderização das abas ---
  const renderInternalHealthcareTab = () => (
    <div className="internalhealthcare-container">
      <form onSubmit={handleInternalHealthcareSubmit} className="evolucao-container">
        <div className="social-form-group-duplo">
          <div className="social-form-group">
            <label>Data</label>
            <input
              type="datetime-local"
              name="date"
              value={internalHealthcareData.date}
              onChange={handleInternalHealthcareChange}
              required
            />
          </div>
          <div className="social-form-group">
            <label>Tipo de atendimento</label>
            <select name="type_care" value={internalHealthcareData.type_care} onChange={handleInternalHealthcareChange} required>
              <option value="">Selecione</option>
              {typeServiceCareOptions.map(tc => (
                <option key={tc.id} value={tc.id}>{tc.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="social-form-group">
          <label>Anamnese <TooltipInfo text="Informações gerais de saúde do interno e de sua família." /> </label>
          <textarea rows={4} type="text" name="anamnesis" value={internalHealthcareData.anamnesis} onChange={handleInternalHealthcareChange} />
        </div>
        <div className="social-form-group">
          <label>Estado geral de saúde</label>
          <textarea rows={4} type="text" name="general_health_status" value={internalHealthcareData.general_health_status} onChange={handleInternalHealthcareChange} required />
        </div>
        <div className="social-form-group">
          <label>Conduta<TooltipInfo text="Tudo que o médico decidir referente à situação de saúde do interno" /> </label>
          <textarea rows={4} type="text" name="conduct" value={internalHealthcareData.conduct} onChange={handleInternalHealthcareChange} required />
        </div>
        <div className="social-form-group">
          <label>Observação</label>
          <textarea rows={5} name="observation" value={internalHealthcareData.observation} onChange={handleInternalHealthcareChange} required />
        </div>
        <div className="social-form-group">
          <button type="submit" className="social-submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar Atendimento Interno'}
          </button>
        </div>
      </form>

      <div className="timeline">
        <h4>Histórico de Atendimentos</h4>
        <ul className="timeline-list">
          {internalHealthcareRecords.length > 0 ? internalHealthcareRecords.map((rec) => (
            <li key={rec.id} className="timeline-item">
              <div className="timeline-date">
                <FontAwesomeIcon icon={faClock} /> {new Date(rec.date).toLocaleDateString()}
                {/* <button
                  type="button"
                  className="edit-icon-button"
                  onClick={() => setEditHealthcare(rec)}
                >
                  <FontAwesomeIcon icon={faPen} />
                </button> */}
              </div>
              <div className="timeline-content">
                <p><strong>Profissional:</strong> {rec.health_professional_name}</p>
                <p><strong>Tipo de atendimento':</strong> {rec.type_care_name}</p>
                <p><strong>Conduta:</strong> {rec.conduct}</p>
                <p><strong>Estado geral de saúde:</strong> {rec.general_health_status}</p>
                <p><strong>Anamnese:</strong> {rec.anamnesis}</p>
                <p><strong>Observação:</strong> {rec.observation}</p>
              </div>
            </li>
          )) : <p>Nenhum atendimento registrado.</p>}
        </ul>
      </div>


    </div>
  );

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container admission-page">
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Consulta Interna"
          subtitle="Atendimento clínico realizado pelo profissional."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <div className="social-tab-content">
            {renderInternalHealthcareTab()}
          </div>
        )}
      </div>

      {/* Modal de consulta interna */}
      {editHealthcare && (
        <ViewModal
          isOpen={!!editHealthcare}
          closeModal={() => setEditHealthcare(null)}
          title="Editar Atendimento"
        >
          <form onSubmit={handleInternalHealthcareUpdate}>
            <div className="social-form-group-duplo">
              <div className="social-form-group">
                <label>Data</label>
                <input
                  type="datetime-local"
                  name="date"
                  value={editHealthcare.date?.slice(0, 16) || ''}
                  onChange={(e) => setEditHealthcare(prev => ({ ...prev, date: e.target.value }))}
                  readOnly
                />
              </div>
              <div className="social-form-group">
                <label>Tipo de atendimento </label>
                <select
                  name="type_care"
                  value={editHealthcare.type_care || ''}
                  onChange={(e) => setEditHealthcare(prev => ({ ...prev, type_care: e.target.value }))}
                  readOnly
                >
                  <option value="">Selecione</option>
                  {typeServiceCareOptions.map(tc => (
                    <option key={tc.id} value={tc.id}>{tc.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className='social-form-group-duplo'>
              <div className="social-form-group">
                <label>Conduta</label>
                <textarea
                  rows={4}
                  name="conduct"
                  value={editHealthcare.conduct || ''}
                  onChange={(e) => setEditHealthcare(prev => ({ ...prev, conduct: e.target.value }))}
                  readOnly
                />
              </div>
              <div className="social-form-group">
                <label>Estado geral de saúde</label>
                <textarea
                  rows={4}
                  name="general_health_status"
                  value={editHealthcare.general_health_status || ''}
                  onChange={(e) => setEditHealthcare(prev => ({ ...prev, general_health_status: e.target.value }))}
                  readOnly
                />
              </div>
            </div>
            <div className='social-form-group-duplo'>
              <div className="social-form-group">
                <label>Anamnese</label>
                <textarea
                  rows={4}
                  name="anamnesis"
                  value={editHealthcare.anamnesis || ''}
                  onChange={(e) => setEditHealthcare(prev => ({ ...prev, anamnesis: e.target.value }))}
                  readOnly
                />
              </div>
            </div>
            <div className="social-form-group">
              <label>Observação</label>
              <textarea
                rows={5}
                name="observation"
                value={editHealthcare.observation || ''}
                onChange={(e) => setEditHealthcare(prev => ({ ...prev, observation: e.target.value }))}
                readOnly
              />
            </div>
          </form>
        </ViewModal>
      )}
    </div>
  );
};

export default InternalCareHealth;
